<template>
  <media-manager 
    v-bind:sourceId="sourceId_Kiosk"
    v-bind:title="title"
    v-bind:kiosks="kiosks"
    v-bind:defaultKioskId="defaultKioskId"
    v-bind:containers="containers"
    v-bind:defaultContainer="defaultContainer"
    v-bind:isAdminMode="isAdminMode"
    v-bind:toolbarColor="toolbarColor"
    v-bind:toolbarColorDark="toolbarColorDark"
  />
</template>

<script>
import appService from '@/app.service'
import MediaManager from '@/components/MediaManager'
import { GenieMediaSourceId, AppColor, KioskTypeId, Container } from '@/config.js'
import { mapGetters } from 'vuex'

export default {
  name: 'KioskMediaManager',
  components: {
    MediaManager
  },
  data() {
    return {
      toolbarColor: AppColor.KioskTypeGenieLight,
      toolbarColorDark: AppColor.KioskTypeGenie,
      sourceId_Kiosk: GenieMediaSourceId.Kiosk,
      kioskTypeId_Genie: KioskTypeId.Genie,
      kioskPrefix: Container.KioskPrefix,

      kiosks: [],
      defaultKioskId: null,
      containers: [],
      defaultContainer: null
    }
  },
  computed: {
    ...mapGetters(['previousRoute', 'isKioskManager', 'activeKiosk']),
    isFromKioskDashboard () {
      return this.previousRoute.indexOf('KioskDashboard') >= 0
      || (this.previousRoute.indexOf('Home') >= 0 && this.isKioskManager)
    },
    isAdminMode () {
      return !this.isFromKioskDashboard
    },
    title () {
      return this.isAdminMode
        ? null
        : this.kioskName
    },
    kioskContainer () {
      if (this.activeKiosk === null) return null
      return this.activeKiosk.container
    },
    kioskName () {
      if (this.activeKiosk === null) return null
      return this.activeKiosk.serialNumber
    },
    activeContainer () {
      return this.isFromKioskDashboard
        ? {
          name: this.kioskContainer,
          displayName: this.kioskName
        }
      : null
    }
  },
  methods: {
    loadData () {
      const self = this

      //-- dashboard mode
      if (self.isFromKioskDashboard) {
        self.defaultKioskId = self.activeKiosk.id
        self.kiosks = [self.activeKiosk]
        self.containers = [self.activeContainer]
        self.defaultContainer = self.activeContainer.name

      // admin mode
      } else {
        appService.getKioskComboboxOptions(self.kioskTypeId_Genie).then(data => {
          if (data.errorSeverity > 0) self.handleError(data)
          else {
            self.kiosks = data.options
            self.containers = self.kiosks.map(k => { return {
              name: k.container,
              displayName: k.name
            }})
            self.defaultKioskId = 0
          } 
        })
      }
    },

    handleError (result) {
      this.$error.show({
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    }
  },
  created() {
    this.loadData()
  }
}
</script>
